import { Menu } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet.tsx';
import { Button } from '@/components/ui/button.tsx';
import { MeSettingsSidebar } from '@/pages/channels/@me/_components/me-settings-sidebar.tsx';
import { useState } from 'react';

export const MobileSettingsToggle = ( ) => {
  const [open, setOpen] = useState(false);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="md:hidden">
          <Menu />
        </Button>
      </SheetTrigger>

      <SheetContent side="left" className="p-0 w-[80%] max-w-sm">
        <MeSettingsSidebar onItemClick={() => setOpen(false)} />
      </SheetContent>
    </Sheet>
  );
};
